<mat-dialog-content>
    @if (step === ActivationStepsEnum.enterMail) {
        <div class="hypo-dialog-header">
            <div class="hypo-dialog-title">Ověřte svůj e-mail</div>
        </div>
        <form
            (ngSubmit)="stepOne()"
            [formGroup]="activationForm"
            novalidate
            [attr.data-testid]="'activation-dialog-step-one'">
            <div class="hypo-dialog-content activation">
                <div class="hnm-dark-text pb-4">
                    Pro neomezený přístup do bankovnictví ověřte svůj e-mail. Je to nezbytné pro ochranu Vašich osobních
                    údajů.
                </div>
                <div class="hnm-dark-text pb-2">E-mailová adresa</div>
                <div class="flex flex-col">
                    <app-hypo-input
                        [inputmode]="'email'"
                        [patternErrorMessage]="'Špatný formát emailu (priklad@domena.cz)'"
                        formControlName="email"
                        class="w-full">
                    </app-hypo-input>
                </div>
                @if (isDevelopingMode) {
                    <button
                        [attr.data-testid]="'activation-dialog-button-generate-email'"
                        (click)="generateRandomEmail()">
                        Email
                    </button>
                }
                <div class="hypo-dialog-footer flex flex-row items-center justify-center">
                    <button
                        class="btn orange btn-lg activation-email"
                        [attr.data-testid]="'activation-dialog-button-continue'"
                        mat-button
                        type="submit">
                        @if (!isLoading) {
                            Pokračovat
                        } @else {
                            <mat-spinner diameter="19"></mat-spinner>
                        }
                    </button>
                </div>
            </div>
        </form>
    }

    @if (step === ActivationStepsEnum.verifyUser) {
        <div class="hypo-dialog-header">
            <div class="hypo-dialog-title">Zadejte ověřovací kód</div>
        </div>
        <form
            (ngSubmit)="stepTwo()"
            [formGroup]="activationForm"
            class="verification-code"
            [attr.data-testid]="'activation-dialog-step-two'"
            novalidate>
            <div class="hypo-dialog-content activation">
                <div class="hnm-dark-text pb-4">
                    Právě jsme zaslali ověřovací kód na zadaný e-mail
                    <span>{{ activationForm?.get('email').value }}</span>
                </div>
                @if (wrongCode && !successCode) {
                    <div class="hnm-warning-text pb-2">Chybný ověřovací kód.</div>
                }
                <div class="hnm-dark-text pb-2">Ověřovací kód</div>
                <div class="verification-code-row">
                    <ng-container formArrayName="activationCode">
                        @for (
                            activationCodeInput of activationCodeForm.controls;
                            track activationCodeInput;
                            let i = $index
                        ) {
                            <mat-form-field floatLabel="always">
                                <input
                                    #activationInput
                                    (keydown)="codeKeyDown($event, i)"
                                    (keyup)="codeKeyEvent($event, i)"
                                    (paste)="codePasteEvent($event, i)"
                                    [formControlName]="i"
                                    class="code-inputs"
                                    id="activation_code_{{ i }}"
                                    matInput
                                    max="9"
                                    name="activation_code_{{ i }}"
                                    required
                                    type="number" />
                            </mat-form-field>
                        }
                    </ng-container>
                </div>
                <div class="hypo-dialog-footer flex flex-col items-center justify-stretch">
                    <button
                        [disabled]="!verifyApprove"
                        class="btn btn-lg orange activation-verify"
                        mat-button
                        [attr.data-testid]="'activation-dialog-button-finish'"
                        type="submit">
                        @if (!isLoading) {
                            Dokončit aktivaci
                        } @else {
                            <mat-spinner diameter="19"></mat-spinner>
                        }
                    </button>
                    <div>
                        <span
                            (click)="changeEmail()"
                            class="link login-change-different-email"
                            [attr.data-testid]="'activation-dialog-button-change-email'">
                            Chci změnit e-mail
                        </span>
                    </div>
                </div>
            </div>
        </form>
    }
</mat-dialog-content>
